// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"rc_a bik_sw bik_kx bik_ky","PostDetailRight__brandDaysPosts":"rc_b bik_sw bik_kx bik_ky"};